import { FontCategory } from '@quicktools/shared-components/data/fonts';
import { useMemo, useState, useEffect } from 'react';

import getFontsByCategory from '../../utils/common/getFontsByCategory';
import getCurrentCategories from '../../utils/common/getCurrentCategories';
import storage from '../../utils/common/localStorage';

export default function useFontsAndCategories(selectedCategory: FontCategory) {
  const [recentsCategoryVisible, setRecentsCategoryVisible] = useState(false);
  const fonts = useMemo(
    () => getFontsByCategory(selectedCategory),
    [selectedCategory, recentsCategoryVisible],
  );

  const [categories, selected] = useMemo(
    () => getCurrentCategories(selectedCategory, recentsCategoryVisible),
    [selectedCategory, recentsCategoryVisible],
  );

  useEffect(() => {
    const hasRecents = storage.getValue().length > 0;

    hasRecents && setRecentsCategoryVisible(true);
  }, []);

  return [categories, selected, fonts, setRecentsCategoryVisible] as const;
}
